import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmCustomersRoute: InvariantJiraRoute = {
	name: 'csm-customers',
	path: '/jira/customer-service-management/customers',
	exact: true,
};
